function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgL = function SvgL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.4 2.2C0 3 0 4.2 0 6.4v3.2c0 2.2 0 3.4.4 4.2.4.8 1 1.4 1.7 1.7.9.5 2.1.5 4.3.5h3.2c2.2 0 3.4 0 4.2-.4.8-.4 1.4-1 1.7-1.7.5-.9.5-2.1.5-4.3V6.4c0-2.2 0-3.4-.4-4.2-.4-.8-1-1.4-1.7-1.7C13 0 11.8 0 9.6 0H6.4C4.2 0 3 0 2.2.4 1.4.8.8 1.4.4 2.2zm5.8 2v7.6h4.4v-1H7.3V4.2H6.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e4e4e6"
    }
  }));
};

export default SvgL;